import { render, staticRenderFns } from "./tjyygj.vue?vue&type=template&id=6452fc0d&scoped=true"
import script from "./tjyygj.vue?vue&type=script&lang=js"
export * from "./tjyygj.vue?vue&type=script&lang=js"
import style0 from "./tjyygj.vue?vue&type=style&index=0&id=6452fc0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6452fc0d",
  null
  
)

export default component.exports